// The `.Scrollbar*` component styles live in
// `components/layout/Scrollbars.styles.js` now. This file only keeps the
// `::-webkit-scrollbar` hack below, which isn't tied to a specific component
// instance and has to stay a true global style.
import { createGlobalStyle } from 'antd-style';

const ScrollbarsStyles = createGlobalStyle(() => ({
  // Hack: https://github.com/malte-wessel/react-custom-scrollbars/issues/127#issuecomment-281445949
  '::-webkit-scrollbar': {
    minWidth: 1,
    minHeight: 1,
  },
}));

export default ScrollbarsStyles;
